(function(app, ng) {

    app.config([
        "$stateProvider", function($stateProvider) {
            $stateProvider.state("Transaction.Determine.ProductChoice",
                {
                    url: "/ProductChoice",
                    component: "productChoice",
                    resolve: {
                        nonRightBridgeProductList: [
                            "transactionProductApi", "$transition$", function(transactionProductApi, $transition$) {
                                return transactionProductApi
                                    .getNonRightBridgeTransactionProducts($transition$.params().transactionId);
                            }
                        ],
                        prevStage: [
                            "transaction", "transactionApi", "_", function(transaction, transactionApi, _) {
                                if (transaction.CapturePoints.length === 0) {
                                    return transactionApi.getDisclosures(transaction.Id).then(function(disclosures) {
                                        return disclosures.length === 0 ? null : "Transaction.Disclose";
                                    });
                                } else
                                    return "Transaction.Capture." +
                                        transaction.CapturePoints[transaction.CapturePoints.length - 1];
                            }
                        ],
                        inforce: [
                            "transaction", "inforceTransactionApi", function(transaction, inforceTransactionApi) {
                                return inforceTransactionApi.get(transaction.Id).catch(ng.noop);
                            }
                        ],
                        states: [
                            "states", function(states) {
                                return states;
                            }
                        ],
                        transactionGroup: [
                            "transactionGroupApi", "userApi", function(transactionGroupApi, userApi) {
                                return userApi.getUserTransactionGroup();
                            }
                        ]
                    },
                    onEnter: [
                        "transaction", "transactionApi", function(transaction, transactionApi) {
                            transaction.LastTransactionStage = "ProductChoice";
                            transactionApi.updateLastTransactionStage(transaction.Id, transaction);
                        }
                    ]
                });
        }
    ]);

    app.component("productChoice",
        {
            templateUrl: "/App/Transaction/Determine/ProductChoice/template.html",
            controller: productChoiceController,
            bindings: {
                nonRightBridgeProductList: "<",
                transaction: "<",
                transactionGroup: "<",
                prevStage: "<",
                inforce: "<",
                states: "<"
            }
        });

    productChoiceController.$inject = ["$state", "$scope", "_", "$mdMedia", "$mdDialog", "rightBridgeApi", "retireUpApi", "transactionApi", "inforceTransactionApi", "arcEnrollments", "arcEnrollmentsApi"];

    function productChoiceController($state, $scope, _, $mdMedia, $mdDialog, rightBridgeApi, retireUpApi, transactionApi, inforceTransactionApi, arcEnrollments, arcEnrollmentsApi) {
        $scope.$parent.$ctrl.getCurrentStage($state);
        var $ctrl = this;

        arcEnrollments.then(function (e) {
            arcEnrollmentsApi.isEnrolled(e.retireUpId).then(function (response) {
                $ctrl.RetireUpIsEnrolled = response;
            });
        });  

        ng.extend($ctrl,
            {
                UI: {},
                activateRightBridgeSso: activateRightBridgeSso,
                activateRetireUpSso: activateRetireUpSso,
                goToProductShelf: goToProductShelf,
                updateJurisdiction: updateJurisdiction,
                inforceApp: inforceApp               
            });

        function inforceApp(event) {
            if ($ctrl.transaction.Jurisdiction) {
                $state.go("Transaction.Determine.Inforce", { transactionId: $ctrl.transaction.Id });
            }
        }

        function activateRightBridgeSso() {
            if ($ctrl.transaction.Jurisdiction) {
                var w = window;
                w.document.write("Loading...");
                rightBridgeApi.initiateRightBridgeSso($ctrl.transaction.Id).then(function(data) {
                        w.document.write(data);
                        w.document.forms.samlform.submit();
                    },
                    function(error) {
                        w.document.write(" Failed.  There was an error accessing this resource.");
                    });
            }
        }  

        function activateRetireUpSso() {
            if ($ctrl.RetireUpIsEnrolled && !!$ctrl.transaction.Jurisdiction) {
                var w = window;
                w.document.write("Loading...");
                retireUpApi.initiateRetireUpSso($ctrl.transaction.Id).then(function(data) {
                        console.log(data)
                        w.document.write(data);
                        w.document.forms.samlform.submit();
                    },
                    function(error) {
                        w.document.write(" Failed.  There was an error accessing this resource.");
                    });
            }
        }  
        function goToProductShelf() {
            if (!!$ctrl.inforce && !!$ctrl.transaction.Jurisdiction)
                inforceTransactionApi.remove($ctrl.inforce.Id);
            $state.go("Transaction.Determine.ProductShelf");
        };

        function updateJurisdiction() {
            transactionApi.updateJurisdiction($ctrl.transaction.Id, $ctrl.transaction);
        };

        this.$onInit = function() {         
            $ctrl.UI.HasRightBridge = $ctrl.transaction.DeterminePoints.includes("Rightbridge");
            $ctrl.UI.HasRetireUp = $ctrl.transaction.DeterminePoints.includes("RetireUp");
        };   
    }     
})(window.app, window.angular);